'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * 判断是否符合邮件格式
 * @param {string} str 
 * @return { Object } result:bool 判断结果; code: Number 错误代号                   
 * code: 100 符合格式     
 * code: 101 未输入             
 * code: 103 格式不正确
 */
function isEmail(str) {
    var format = /^[\w_\.\-\+]+@[\w_\.\-\+]+\.[a-zA-Z]{2,5}$/;
    if (str === "") return {
        result: false,
        code: 101
    };else if (!format.test(str)) return {
        result: false,
        code: 103
    };else return {
        result: true,
        code: 100
    };
}

/**
 * 判断手机号是否符合格式
 * @param {String} str 
 * @return { Object } result:bool 判断结果; code: Number 错误代号                     
 * code: 100 符合格式     
 * code: 101 未输入               
 * code: 103 格式不正确
 */
function isPhone(str) {
    var format = /^(13|14|15|17|18|19|16)\d{9}$/;
    if (str === "") return {
        result: false,
        code: 101
    };else if (format.test(str)) return {
        result: true,
        code: 100
    };else return {
        result: false,
        code: 103
    };
}

/**
 * 判断密码是否合法
 * @param {String} str  
 * @return { Object } result:bool 判断结果; code: Number 错误代号                       
 * code: 100 符合格式     
 * code: 101 未输入       
 * code: 103 格式不正确      
 * code: 201 密码长度在6-32位外或包含有空格符号     
 * code: 202 密码不能全为数字         
 * code: 203 密码不能全为特殊符号    
 * code: 204 密码长度小于6         
 * code: 205 密码长度大于32      
 * code: 206 密码不能全为字母
 */
function isPassword(str) {
    var format = /^[\S]{6,32}$/;
    if (str === "") return {
        result: false,
        code: 101
    };
    if (str.length < 6) return {
        result: false,
        code: 204
    };else if (str.length > 32) return {
        result: false,
        code: 205
    };else if (!format.test(str)) return {
        result: false,
        code: 201
    };else if (/^[\u4e00-\u9fa5]{2,50}$/.test(str)) return {
        result: false,
        code: 103
    };else if (!/^[a-zA-Z]+$/.test(str) && !/^[0-9]+$/.test(str) && !/^[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/.test(str) && !/^[\u4e00-\u9fa5]{2,50}$/.test(str)) return {
        result: true,
        code: 100
    };else {
        if (/^[a-zA-Z]+$/.test(str)) {
            return {
                result: false,
                code: 206
            };
        }
        if (/^[0-9]+$/.test(str)) {
            return {
                result: false,
                code: 202
            };
        }
        if (/^[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/.test(str)) {
            return {
                result: false,
                code: 203
            };
        }
        return {
            result: false,
            code: 103
        };
    }
}

/**
 * 判断用户名
 * @param {String} str 
 * @return { Object } result:bool 判断结果; code: Number 错误代号                     
 * code: 100 符合格式     
 * code: 101 未输入              
 * code: 103 格式不正确 
 */
function isUserName(str) {
    var isEnglisdName = /^[a-zA-Z▪•\.·()]{1,40}$/;
    var isChineseName = /^[\u4e00-\u9fa5\.·▪•（）]{1,20}$/;
    if (str === "") return {
        result: false,
        code: 101
    };else if (isEnglisdName.test(str) || isChineseName.test(str)) return {
        result: true,
        code: 100
    };else return {
        result: false,
        code: 103
    };
}

/**
 * 验证是否为合法的身份证号
 * @param {String} str 
 * @return { Object } result:bool 判断结果; code: Number 错误代号               
 * code: 100 符合格式         
 * code: 101 未输入    
 * code: 103 身份证号格式错误            
 * code: 301 地址编码错误           
 * code: 302 校验位错误
 * code: 303 含有空格
 */
function isIDCard(str) {
    var city = {
        11: "北京", 12: "天津", 13: "河北", 14: "山西",
        15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江",
        31: "上海", 32: "江苏", 33: "浙江", 34: "安徽",
        35: "福建", 36: "江西", 37: "山东", 41: "河南",
        42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西",
        46: "海南", 50: "重庆", 51: "四川", 52: "贵州",
        53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃",
        63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾",
        81: "香港", 82: "澳门", 91: "国外 "
    };
    var format = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i;
    if (str === "") {
        return {
            result: false,
            code: 101
        };
    } else if (str.indexOf(" ") !== -1) {
        return {
            result: false,
            code: 303
        };
    } else if (!format.test(str)) {
        return {
            result: false,
            code: 103
        };
    } else if (!city[str.substr(0, 2)]) {
        return {
            result: false,
            code: 301
        };
    } else {
        if (str.length === 18) {
            str = str.split("");
            var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            //校验位
            var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
            var sum = 0;
            var ai = 0;
            var wi = 0;
            for (var i = 0; i < 17; i++) {
                ai = str[i];
                wi = factor[i];
                sum += ai * wi;
            }
            if (str[17] === "x") str[17] = str[17].toUpperCase();
            if (parity[sum % 11] != str[17]) {
                return {
                    result: false,
                    code: 302
                };
            }
        }
    }
    return {
        result: true,
        code: 100
    };
}

/**
 * 验证是否为合法的身份证号
 * @param {String} str 
 * @return { Object } result:bool 判断结果; code: Number 错误代号               
 * code: 100 符合格式         
 * code: 101 未输入    
 * code: 103 身份证号格式错误                      
 * code: 303 含有空格
 */
function isHKCard(str) {
    var format = /^((\s?[A-Za-z])|([A-Za-z]{2}))\d{6}(\([0-9aA]\)|（[0-9aA]）|[0-9aA])$/;

    if (str === "") {
        return {
            result: false,
            code: 101
        };
    } else if (!format.test(str)) {
        return {
            result: false,
            code: 103
        };
    }
    return {
        result: true,
        code: 100
    };
}

function isTWCard(str) {
    var format = /^[a-zA-Z][0-9]{9}$/;

    if (str === "") {
        return {
            result: false,
            code: 101
        };
    } else if (!format.test(str)) {
        return {
            result: false,
            code: 103
        };
    }
    return {
        result: true,
        code: 100
    };
}

function isMacaoCard(str) {
    var format = /^[1|5|7][0-9]{6}(\([0-9Aa]\)|（[0-9Aa]）)$/;

    if (str === "") {
        return {
            result: false,
            code: 101
        };
    } else if (!format.test(str)) {
        return {
            result: false,
            code: 103
        };
    }
    return {
        result: true,
        code: 100
    };
}

/**
 * 判断银行卡号是否合法
 * @param {String} str 
 * @return { Object } result:bool 判断结果; code: Number 错误代号           
 * code: 100 符合格式             
 * code: 101 未输入   
 * code: 103 银行卡号格式错误
 */

function isBankCode(str) {
    if (str === "") return {
        result: false,
        code: 101
    };
    var lastNum = str.substr(str.length - 1, 1); //取出最后一位（与luhm进行比较）  
    var first15Num = str.substr(0, str.length - 1); //前15或18位  
    var newArr = [];

    for (var i = first15Num.length - 1; i > -1; i--) {
        //前15或18位倒序存进数组  
        newArr.push(first15Num.substr(i, 1));
    }

    var arrJiShu = []; //奇数位*2的积 <9  
    var arrJiShu2 = []; //奇数位*2的积 >9  
    var arrOuShu = []; //偶数位数组  

    for (var j = 0; j < newArr.length; j++) {
        if ((j + 1) % 2 == 1) {
            //奇数位  
            if (parseInt(newArr[j]) * 2 < 9) arrJiShu.push(parseInt(newArr[j]) * 2);else arrJiShu2.push(parseInt(newArr[j]) * 2);
        } else //偶数位  
            arrOuShu.push(newArr[j]);
    }
    var jishu_child1 = []; //奇数位*2 >9 的分割之后的数组个位数  
    var jishu_child2 = []; //奇数位*2 >9 的分割之后的数组十位数 

    for (var h = 0; h < arrJiShu2.length; h++) {
        jishu_child1.push(parseInt(arrJiShu2[h]) % 10);
        jishu_child2.push(parseInt(arrJiShu2[h]) / 10);
    }
    var sumJiShu = 0; //奇数位*2 < 9 的数组之和  
    var sumOuShu = 0; //偶数位数组之和  
    var sumJiShuChild1 = 0; //奇数位*2 >9 的分割之后的数组个位数之和  
    var sumJiShuChild2 = 0; //奇数位*2 >9 的分割之后的数组十位数之和  
    var sumTotal = 0;

    for (var m = 0; m < arrJiShu.length; m++) {
        sumJiShu = sumJiShu + parseInt(arrJiShu[m]);
    }

    for (var n = 0; n < arrOuShu.length; n++) {
        sumOuShu = sumOuShu + parseInt(arrOuShu[n]);
    }

    for (var p = 0; p < jishu_child1.length; p++) {
        sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p]);
        sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p]);
    }
    //计算总和  
    sumTotal = parseInt(sumJiShu) + parseInt(sumOuShu) + parseInt(sumJiShuChild1) + parseInt(sumJiShuChild2);

    //计算Luhm值  
    var k = parseInt(sumTotal) % 10 == 0 ? 10 : parseInt(sumTotal) % 10;
    var luhm = 10 - k;

    if (lastNum == luhm && lastNum.length != 0) {
        //Luhm验证通过且不为空 
        return {
            result: true,
            code: 100
        };
    } else {
        //不符合Luhm校验
        return {
            result: false,
            code: 103
        };
    }
}

/**
 * 对公银行账号 //由于各银行卡信息未知暂时不限制上限
 * @param {String} str 
 * @return { Object } result:bool 判断结果; code: Number 错误代号            
 * code: 100 符合格式               
 * code: 101 未输入   
 * code: 103 对公银行账号格式错误
 */
function isPublicBankCode(str) {
    var format = /^[0-9]{9,}$/;
    if (str === "") return {
        result: false,
        code: 101
    };else if (format.test(str)) return {
        result: true,
        code: 100
    };else return {
        result: false,
        code: 103
    };
}

/**
     * 判断银行名
     * @param {String} str 
     * @return { Object } result:bool 判断结果; code: Number 错误代号            
     * code: 100 符合格式               
     * code: 101 未输入   
     * code: 906 带有空格         
     * code: 903 账号长度小于2           
     * code：904 账号长度大于30          
     * code: 905 银行名称不合法 
     */
function isBankName(str) {
    var format = /^[\u4e00-\u9fa5]{2,30}$/;
    if (str === "") return {
        result: false,
        code: 101
    };
    if (str.indexOf(" ") !== -1) return {
        result: false,
        code: 906
    };else if (str.length < 2) return {
        result: false,
        code: 903
    };else if (str.length > 30) return {
        result: false,
        code: 904
    };else if (format.test(str)) return {
        result: true,
        code: 100
    };else return {
        result: false,
        code: 905
    };
}

/**
 * 判断是否为社会信用代号
 * @param {String} str 
 * @return { Object } result:bool 判断结果; code: Number 错误代号            
 * code: 100 符合格式              
 * code: 101 未输入    
 * code: 401 社会信用代号长度必须为18位          
 * code: 402 包含非法字符(除大写英文字符和数字字符)         
 * code: 403 校验码错误
 */
function isCreditCode(str) {
    //字符集数组
    var fin_array = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "P", "Q", "R", "T", "U", "W", "X", "Y"];
    //加权数组
    var i_array = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28];
    //结果数组
    var val_array = [];
    //相乘数组
    var ch_array = [];
    //Sigma
    var sigma = 0;
    if (str === "") {
        return {
            result: false,
            code: 101
        };
    } else if (str.length != 18) {
        /* return "统一社会信用代码长度必须为18位.";*/
        return {
            result: false,
            code: 401
        };
    } else {
        //转换成字符集的值
        for (var i = 0; i < 17; i++) {
            val_array[i] = fin_array.indexOf(str.charAt(i));
        }
        //console.log(val_array);
        //校验是否包含字符集之外的字符
        for (var _i = 0; _i < 17; _i++) {
            if (val_array[_i] == -1) {
                /*return "包含非法字符";*/
                return {
                    result: false,
                    code: 402
                };
            }
        }
        //生成加权结果
        for (var _i2 = 0; _i2 < 17; _i2++) {
            ch_array[_i2] = val_array[_i2] * i_array[_i2];
        }
        //console.log(ch_array);
        //求出Sigma
        for (var _i3 = 0; _i3 < 17; _i3++) {
            sigma = sigma + ch_array[_i3];
        }
        //console.log(sigma);
        //求出校验位
        var vali = fin_array[(31 - sigma % 31) % 31];
        //查看校验码是否正确
        if (str.charAt(17) == vali) {
            /*return "正确";*/
            return {
                result: true,
                code: 100
            };
        } else {
            /*return "校验码错误: 应该为: " + vali;*/
            return {
                result: false,
                code: 403
            };
        }
    }
}

/**
 * 判断组织名称是否合法
 * @param {String} str 
 * @return { Object } result:bool 判断结果; code: Number 错误代号                     
 * code: 100 符合格式     
 * code: 101 未输入              
 * code: 501 名称为2-50个中文或英文的字符且不包含空格    
 * code: 502 组织机构名称长度不得小于2                    
 * code: 503 组织机构名称长度不得大于50     
 */
function isOrganizationName(str) {
    var format = /^[-（）().·▪•\u4e00-\u9fa5A-Za-z]{2,50}$/;
    if (str === "") return {
        result: false,
        code: 101
    };else if (str.length < 2) return {
        result: false,
        code: 502
    };else if (str.length > 50) return {
        result: false,
        code: 503
    };else if (!format.test(str)) {
        return {
            result: false,
            code: 501
        };
    } else return {
        result: true,
        code: 100
    };
}

/**
 * 组织机构代码校验
 * @param {String} str 
 * @return { Object } result:bool 判断结果; code: Number 错误代号                  
 * code: 100 符合格式       
 * code: 101 未输入                        
 * code: 103 格式不正确            
 * code: 507 长度为9或10位，校验位错误或带有其他字符           
 * code: 504 长度非9或10位
 * code: 505 长度为10时，-被其他字符取代
 * code: 506 包含空格
 */
function isOrganizationCode(str) {
    var codeVal = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
    var intVal = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35];
    var crcs = [3, 7, 9, 10, 5, 8, 4, 2];
    if (str.indexOf(" ") !== -1) {
        return {
            result: false,
            code: 506
        };
    }
    if (!("" == str) && (str.length == 10 || str.length == 9)) {
        if (str.length === 10) {
            if (str.lastIndexOf("-") !== 8) {
                return {
                    result: false,
                    code: 505
                };
            }
        }
        var sum = 0;
        for (var i = 0; i < 8; i++) {
            var codeI = str.substring(i, i + 1);
            var valI = -1;
            for (var j = 0; j < codeVal.length; j++) {
                if (codeI == codeVal[j]) {
                    valI = intVal[j];
                    break;
                }
            }
            sum += valI * crcs[i];
        }
        var crc = 11 - sum % 11;
        switch (crc) {
            case 10:
                {
                    crc = "X";
                    break;
                }case 11:
                {
                    crc = "0";
                    break;
                }default:
                {
                    break;
                }
        }
        //最后位验证码正确
        if (crc == str.substring(9) || crc == str.substring(8)) {
            return {
                result: true,
                code: 100
            };
        } else {
            return {
                result: false,
                code: 507
            };
        }
    } else if ("" == str) {
        return {
            result: false,
            code: 101
        };
    } else {
        return {
            result: false,
            code: 504 //'填写格式为：8位数字（或大写拉丁字母）+ "-" + 1位数字（或大写拉丁字母）校验码，例如：12345678-9' ;	
        };
    }
}

/**
 * 工商注册号
 * @param {String} str 
 * @return { Object } result:bool 判断结果; code: Number 错误代号         
 * code: 100 符合格式     
 * code: 101 未输入   
 * code: 601 注册号长度为15位    
 * code: 602 工商注册号错误
 */
function isBusinessRegistrationCode(str) {
    if (str.length == 15) {
        var s = [];
        var p = [];
        var a = [];
        var m = 10;
        p[0] = m;
        for (var i = 0, l = str.length; i < l; i++) {
            a[i] = parseInt(str.substring(i, i + 1), m);
            s[i] = p[i] % (m + 1) + a[i];
            if (0 == s[i] % m) {
                p[i + 1] = 10 * 2;
            } else {
                p[i + 1] = s[i] % m * 2;
            }
        }
        if (1 == s[14] % m) {
            return {
                result: true,
                code: 100
            };
        } else {
            return {
                result: false,
                code: 602
            };
        }
    } else if (str == "") {
        return {
            result: false,
            code: 101
        };
    } else {
        return {
            result: false,
            code: 601
        };
    }
}

/**
 * 判断护照是否符合格式
 * @param {String} str 
 * @return { Object } result:bool 判断结果; code: Number 错误代号                       
 * code: 100 符合格式     
 * code: 101 未输入  
 * code: 103 格式不正确
 */
function isPassPortCode(str) {
    var format1 = /^1[45][0-9]{7}$|^G[0-9]{8}$|^E[0-9]{7,8}$|^K[0-9]{7,8}$|^K[a-zA-Z][0-9]{7,8}$|^P[0-9]{7}$|^S[0-9]{7,8}$|^D[0-9]+$/;
    var format2 = /^[a-zA-Z0-9]{5,21}$/;

    if (str === "") return {
        result: false,
        code: 101
    };else if (!format1.test(str) || !format2.test(str)) return {
        result: false,
        code: 103
    };else return {
        result: true,
        code: 100
    };
}

/**
 * 纳税人名字
 * @param {String} str 
 * @return { Object } result:bool 判断结果; code: Number 错误代号                   
 * code: 100 符合格式     
 * code: 101 未输入     
 * code: 701 纳税人名长度在1-50内            
 * code: 702 纳税人名必须为中文
 */
function isTaxName(str) {
    var format = /^[\u4e00-\u9fa5]{2,50}$/;
    if (str === "") return {
        result: false,
        code: 101
    };else if (format.test(str)) return {
        result: true,
        code: 100
    };else if (str.length < 1 || str.length > 50) {
        return {
            result: false,
            code: 701
        };
    } else return {
        result: false,
        code: 702
    };
}
function isTaxID(str) {
    var format = /^[A-Za-z0-9]{20}$|^[A-Za-z0-9]{18}$|^[A-Za-z0-9]{15}$/;
    if (str.indexOf(" ") !== -1) {
        return {
            result: false,
            code: 707
        };
    }
    if (str === "") return {
        result: false,
        code: 101
    };else if (!format.test(str)) return {
        result: false,
        code: 703
    };else if (str.length === 15) {
        var address = str.substring(0, 6);
        var city = {
            11: "北京", 12: "天津", 13: "河北", 14: "山西",
            15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江",
            31: "上海", 32: "江苏", 33: "浙江", 34: "安徽",
            35: "福建", 36: "江西", 37: "山东", 41: "河南",
            42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西",
            46: "海南", 50: "重庆", 51: "四川", 52: "贵州",
            53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃",
            63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾",
            81: "香港", 82: "澳门", 91: "国外 "
        };
        var addressCheck = /^[1-9]\d{5}$/.test(address);
        if (!addressCheck) return {
            result: false,
            code: 704
        };else if (!city[address.substring(0, 2)]) return {
            result: false,
            code: 704
        };else {
            var organization = str.substr(6, 9);
            var res = isOrganizationCode(organization).result;
            if (res) {
                return {
                    result: true,
                    code: 100
                };
            } else {
                return {
                    result: false,
                    code: 705
                };
            }
        }
    } else if (str.length === 18) {
        var _res = isIDCard(str);
        if (_res.code === 301) return {
            result: false,
            code: 704
        };else if (_res.code === 302) return {
            result: false,
            code: 706
        };else if (_res.code === 303) return {
            result: false,
            code: 703
        };else return _res;
    } else if (str.length === 20) {
        var _format = /^[A-Za-z0-9\S]{20}$/;
        if (_format.test(str)) return {
            result: true,
            code: 100
        };else return {
            result: false,
            code: 708
        };
    } else return {
        result: false,
        code: 703
    };
}

/**
 * 判断邮寄地址
 * @param {String} str 
 * @return { Object } result:bool 判断结果; code: Number 错误代号              
 * code: 100 符合格式           
 * code: 101 未输入      
 * code: 103 邮寄地址不合法        
 * code: 801 邮寄地址长度不能超过50位    
 * code: 802 邮寄地址长度不能小于6位    
 * code: 803 邮寄地址不能包含特殊字符    
 * code: 804 邮寄地址不能全为数字
 */
function isAddress(str) {
    var formatLength = /^[\S]{6,50}$/;
    var formatNumber = /^[0-9]+$/;
    var formatSpecial = /[ !"#$￥%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/;

    if (str === "") return {
        result: false,
        code: 101
    };else if (!formatLength.test(str)) {
        if (str.length > 50) return {
            result: false,
            code: 801
        };else if (str.length < 6) return {
            result: false,
            code: 802
        };else return {
            result: false,
            code: 103
        };
    } else if (formatSpecial.test(str)) return {
        result: false,
        code: 803
    };else if (formatNumber.test(str)) return {
        result: false,
        code: 804
    };else return {
        result: true,
        code: 100
    };
}

exports.isEmail = isEmail;
exports.isPhone = isPhone;
exports.isPassword = isPassword;
exports.isUserName = isUserName;
exports.isIDCard = isIDCard;
exports.isHKCard = isHKCard;
exports.isTWCard = isTWCard;
exports.isMacaoCard = isMacaoCard;
exports.isCreditCode = isCreditCode;
exports.isAddress = isAddress;
exports.isBusinessRegistrationCode = isBusinessRegistrationCode;
exports.isPassPortCode = isPassPortCode;
exports.isBankCode = isBankCode;
exports.isPublicBankCode = isPublicBankCode;
exports.isBankName = isBankName;
exports.isOrganizationName = isOrganizationName;
exports.isOrganizationCode = isOrganizationCode;
exports.isTaxName = isTaxName;
exports.isTaxID = isTaxID;
